module.exports = __webpack_public_path__ + "media/images/icons/twotone/highlight-698ac907242644bcf7f875ae4ee159d5.svg";